import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export const locationFreightPricingQueryAtom = createQueryAtomFactory(
  'trade.locationFreightPricings',
  (params: { locationId: string }) => ({
    locationFreightPricings: {
      __args: {
        filter: {
          locationId: params.locationId,
        },
      },
      entries: {
        id: true,
        locationId: true,
        supplierFreightEnabled: true,
        supplierRateFormula: true,
        supplierRateVariableIds: true,
        supplierChargebackFormula: true,
        supplierChargebackVariableIds: true,
        supplierFuelSurchargeFormula: true,
        supplierFuelSurchargeVariableIds: true,
        supplierFuelSurchargeMode: true,
        consumerFreightEnabled: true,
        consumerRateFormula: true,
        consumerRateVariableIds: true,
        consumerChargebackFormula: true,
        consumerChargebackVariableIds: true,
        consumerFuelSurchargeFormula: true,
        consumerFuelSurchargeVariableIds: true,
        consumerFuelSurchargeMode: true,
        consumerNegativeCharge: true,
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
    },
  }),
  {
    select: (data) => data.locationFreightPricings.entries[0] ?? null,
  },
);
